module.exports = __webpack_public_path__ + "static/img/en12.7621e15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contact/en12.jpg
// module id = GnWv
// module chunks = 1